import { useTranslation } from 'react-i18next';

import CustomButton from '../../../../shared/components/Buttons/CustomButton/CustomButton';
import BdsTextButton from '../../../../shared/components/Buttons/TextButton/TextButton';
import { ARROW_LEFT_ICON } from '../../../../shared/constants/images';
import { IAuthError } from '../../../../shared/interfaces/auth';
import { TRANSLATIONS_AUTH } from '../../../../shared/translations/auth';
import './AuthError.scss';

const AuthError = ({ title, description, primaryButton, secondaryButton, handleGoBack }: IAuthError) => {
  const { t } = useTranslation();

  return (
    <div className="auth__card">
      <div className="auth__go-back">
        <BdsTextButton action={() => handleGoBack(0)} iconLeft={ARROW_LEFT_ICON} variant="primary">
          {t(TRANSLATIONS_AUTH.goBack)}
        </BdsTextButton>
      </div>
      <div className="flex flex-col auth-error">
        <div className="flex flex-col auth-error__content">
          <div className="auth-error__title whitespace-pre-wrap text-center">{t(title)}</div>
          <div className="auth-error__description whitespace-pre-wrap text-center">{t(description)}</div>
        </div>
        <div className="flex flex-col auth-error__actions">
          {secondaryButton && (
            <CustomButton variant="default" size="l" onClick={secondaryButton.action}>
              {t(secondaryButton.text)}
            </CustomButton>
          )}
          <CustomButton variant="primary" size="l" onClick={primaryButton.action}>
            {t(primaryButton.text)}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default AuthError;
